import { useEffect, useState } from 'react';
import { FiMail, FiPhone } from 'react-icons/fi';
import { GrLocation } from 'react-icons/gr';
import { RiBook2Line } from 'react-icons/ri';
import { useParams, useNavigate } from 'react-router-dom';
import {} from 'react-router';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import {
  ErrorMessageHandler
  //  mediaUrlify
} from '../../../../_helpers/_methods';
import UserImage from '../../../../Components/UserImage';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { VscLoading } from 'react-icons/vsc';
import { Button } from 'react-bootstrap';
import { BsFillCalendarEventFill, BsPeople, BsBuilding } from 'react-icons/bs';
import EventCard from './Component/Events/EventCard';
import UserDetail from '../../../../Components/UserDetail';
import { checkPermission } from '../../../../_helpers/roles/check-roles';

function Profile({ profileType }) {
  const { id } = useParams();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user.user);
  const lang = useSelector((state) => state.local.local);

  const [userData, setUserData] = useState({});
  const [userStats, setUserStats] = useState({});
  const [isloading, setIsLoading] = useState(false);

  useEffect(() => {
    const getData = async (id) => {
      try {
        setIsLoading(true);
        if (
          ['superuser', 'cd-admin', 'executive', 'participant', 'resource-person'].includes(
            profileType
          )
        ) {
          let response = await fetchWrapper.get(`/profile/${profileType}/${id}/`);
          let data = response.data;
          if (['superuser', 'cd-admin', 'executive'].includes(profileType)) {
            data = { ...data, user: data };
          }
          setUserData(data);

          let res = await fetchWrapper.get(`/profile/${profileType}/${id}/stats/`);
          setUserStats(res.data);
        } else {
          profileType = user.active_role.split('_').join('-');
          let response = await fetchWrapper.get(`/profile/${profileType}/${id}/`);
          setUserData(response.data);
          console.log(response, 'rep');
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);

        ErrorMessageHandler(error);
      }
    };
    if (profileType == 'me') {
      getData(user?.profile_id || user?.id);
    } else {
      getData(id);
    }
  }, [profileType, user]);

  const navigateEdit = () => {
    let finalProfileType = profileType;
    let finalId = id;
    if (finalProfileType === 'me') {
      finalProfileType = user.active_role.split('_').join('-');
      finalId = user?.profile_id || user?.id;
    }
    console.log(finalProfileType, 'finalProfileType');
    if (finalProfileType === 'participant') {
      navigate(`/admin/trainees/${finalId}/edit`);
    } else if (finalProfileType === 'resource-person') {
      navigate(`/admin/rosters/individual/${finalId}/edit`);
    } else if (finalProfileType === 'executive') {
      navigate(`/admin/users/executives/edit/${finalId}`);
    } else if (finalProfileType === 'cd-admin') {
      navigate(`/admin/users/cd_admins/edit/${finalId}`);
    }
  };

  const downloadProfile = async (id) => {
    try {
      let response = await fetchWrapper.get(`/profile/resource-person/${id}/profile_pdf/`);
      console.log(response.data);
      const link = document.createElement('a');
      link.href = response?.data?.uri;
      link.setAttribute('download', 'Profile.pdf');
      link.setAttribute('target', '_blank');
      link.setAttribute('hidden', true);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };
  const CAN_EDIT = checkPermission(user?.active_role, 'edit profile', {
    userProfileId: user?.profile_id,
    profileId: userData?.id
  });

  return isloading ? (
    <div className="card content-section d-flex justify-content-center center">
      <VscLoading className="spin " size={45} />
    </div>
  ) : (
    <div className="profile-container">
      <div className="card profile-card">
        <div className="row">
          <div className="col-md-3 profile-personal-info">
            <div className="profile-avatar">
              <UserImage
                id={profileType === 'me' ? user?.id : userData?.id}
                avatar={userData?.user?.image || userData?.image || null}
                userName={userData?.user?.fullname || userData?.fullname || 'CD'}
                userId={String(userData?.id)}
                style={{ width: '100px', height: '100px' }}
                size="md"
                fontSize={100}
              />
              <h4 className=" gray-100">{userData?.user?.fullname || userData?.fullname}</h4>
              <p className="font-20-regular primary">
                {userData?.user?.active_role || userData?.active_role}
              </p>
              {CAN_EDIT && (
                <Button variant="outline-primary" className="d-block w-100" onClick={navigateEdit}>
                  <FormattedMessage id="edit_profile_btn" />
                </Button>
              )}
            </div>
            <hr className="w-100" />
            <div className="profile-detail w-100">
              <p className="bg-success text-white w-max-content rounded px-2">
                {userData?.user?.gender || userData?.gender}
              </p>
              <p>
                <FiMail /> {userData?.user?.email || userData?.email}
              </p>
              <p>
                <FiPhone /> {userData?.user?.phone || userData?.phone}
              </p>
              <p>
                <GrLocation />
                <span>
                  {userData?.user?.address?.map((item) => (
                    <span key={item.id}>
                      {item?.municipality + ',' + item?.district + ',' + item?.province}
                    </span>
                  ))}
                </span>
              </p>
              {userData?.ethenicity && (
                <p>
                  <BsPeople />
                  {userData?.ethenicity?.title}
                </p>
              )}
            </div>
            {profileType === 'participant' && (
              <>
                <hr className="w-100" />
                <div className="profile-detail w-100">
                  <div className="d-flex align-items-start gap-2 fw-bold">
                    <div>
                      {userData?.employee_type?.map((type) => (
                        <p key={type.id} className="">
                          {type.title}
                        </p>
                      ))}
                    </div>
                  </div>
                  <p>
                    {' '}
                    <BsBuilding />
                    {userData?.office_name}
                  </p>
                  <p>
                    <GrLocation /> {userData?.office_address?.municipality},{' '}
                    {userData?.office_address?.district}, {userData?.office_address?.province}
                  </p>
                </div>
              </>
            )}
            {profileType === 'resource-person' && userData?.user?.qualification?.length !== 0 && (
              <>
                <hr className="w-100" />
                <div>
                  <>
                    {['superuser', 'cd-admin', 'executive'].includes(
                      userData.active_role
                    ) ? null : (
                      <p className="fw-bold gray-100">
                        <FormattedMessage id="education_qualification" /> :
                      </p>
                    )}

                    {userData?.user?.qualification?.map((qualification) => {
                      return (
                        <div className="row mt-3" key={qualification.id}>
                          <div className="d-flex">
                            <div className="row mb-2">
                              <div className="col-md-6 d-flex ">
                                <p className="fw-bold gray-100">
                                  <FormattedMessage id="qualification" /> :
                                </p>
                                <p className=" gray-100 pl-2">{qualification.level}</p>
                              </div>
                              <div className="  col-md-6 d-flex">
                                <p className="fw-bold gray-100">
                                  <FormattedMessage id="passed_year" /> :
                                </p>
                                <p className="gray-100 pl-2">{qualification.final_year}</p>
                              </div>
                              <div className=" col-md-6 text-nowrap d-flex">
                                <p className="fw-bold gray-100">
                                  <FormattedMessage id="faculty" /> :
                                </p>
                                <p className=" gray-100 pl-2">{qualification.sector}</p>
                              </div>
                              <div className=" col-md-6 d-flex">
                                <p className="fw-bold gray-100">
                                  <FormattedMessage id="secured_grade" /> :
                                </p>
                                <p className=" gray-100 pl-2">
                                  {qualification.grade.split(' ')[0]}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                </div>
              </>
            )}
            {profileType === 'cd-admin' && (
              <div className="w-100">
                <hr />
                <div>
                  <UserDetail id="office_type" value={userData?.office_type} />
                  <UserDetail id="province" value={userData?.province?.title} />
                  <UserDetail id="office_name" value={userData?.office_name} />
                  <UserDetail id="office_address" value={userData?.office_address?.address} />
                </div>
              </div>
            )}
          </div>
          <div className="col-md-8 profile-info">
            <div className="profile-stats">
              <div className="profile-stats-card">
                <div className="profile-stats-icon">
                  <BsFillCalendarEventFill />
                </div>
                <div className="profile-stats-detail">
                  <h5>
                    <FormattedMessage id="events_enrolled" />
                  </h5>
                  <h3>{userStats?.events}</h3>
                </div>
              </div>
              {profileType !== 'cd-admin' && (
                <div className="profile-stats-card">
                  <div className="profile-stats-icon">
                    <RiBook2Line />
                  </div>
                  <div className="profile-stats-detail">
                    <h5>
                      <FormattedMessage id="thematic_areas" />
                    </h5>
                    <h3>{userStats?.thematic_areas_count}</h3>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              {profileType !== 'cd-admin' && (
                <div className="col-md-6 mb-4">
                  <div className="card">
                    <div className="card-header">
                      <h5>
                        <FormattedMessage id="thematic_areas" />
                      </h5>
                    </div>
                    <div className="card-body">
                      <EventCard items={userStats?.thematic_areas} thematic_area />
                    </div>
                  </div>
                </div>
              )}
              <div className="col-md-6 mb-4">
                <div className="card">
                  <div className="card-header">
                    <h5>
                      <FormattedMessage id="ongoing_events" />
                    </h5>
                  </div>
                  <div className="card-body">
                    <EventCard items={userStats?.ongoing} />
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className="card">
                  <div className="card-header">
                    <h5>
                      <FormattedMessage id="upcoming_events" />
                    </h5>
                  </div>
                  <div className="card-body">
                    <EventCard items={userStats?.upcoming} />
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className="card">
                  <div className="card-header">
                    <h5>
                      <FormattedMessage id="completed_events" />
                    </h5>
                  </div>
                  <div className="card-body">
                    <EventCard items={userStats?.completed} />
                  </div>
                </div>
              </div>
            </div>
            {profileType === 'resource-person' && (
              <div className="card p-4 profile-detail-rp">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="mb-3 fw-bold">
                    <FormattedMessage id="profile" />
                  </h4>
                  <Button onClick={() => downloadProfile(id)}>Export to PDF</Button>
                </div>
                <hr />
                <div className="rp-detail-box">
                  <div className=" mb-5">
                    <h6 className="fw-bold">
                      <FormattedMessage id="personal_details" />
                    </h6>
                    <hr />
                    <UserDetail
                      id="event.fullname"
                      value={userData?.user?.fullname || userData?.fullname}
                    />
                    <UserDetail id="phone" value={userData?.user?.phone || userData?.phone} />
                    <UserDetail id="email" value={userData?.user?.email || userData?.email} />
                    <UserDetail id="event.pan" value={userData?.user?.pan || userData?.pan} />
                    <UserDetail id="event.ethnicity" value={userData?.user?.ethenicity?.title} />
                  </div>
                  <div className=" mb-5">
                    <h6 className="fw-bold">
                      <FormattedMessage id="address" />
                    </h6>
                    <hr />
                    {userData?.user?.address?.map((item) => (
                      <div key={item.id}>
                        <UserDetail id="province" value={item.province} />
                        <UserDetail id="district" value={item.district} />
                        <UserDetail id="municipality" value={item.municipality} />
                        <UserDetail id="ward" value={item.ward} />
                        <UserDetail id="tole" value={item.tole} />
                      </div>
                    ))}
                  </div>
                  <div className=" mb-5">
                    <h6 className="fw-bold">
                      <FormattedMessage id="education_qualification" />
                    </h6>
                    <hr />
                    {userData?.user?.qualification?.map((item, index) => (
                      <div
                        key={item.id}
                        className={`${
                          userData?.user?.qualification?.length !== 1 &&
                          index !== userData?.user?.qualification?.length - 1 &&
                          'mb-3'
                        }`}>
                        <UserDetail id="qualification" value={item.level} />
                        <UserDetail id="faculty" value={item.sector} />
                        <UserDetail id="secured_grade" value={item.grade} />
                        <UserDetail id="passed_year" value={item.final_year} />
                      </div>
                    ))}
                  </div>
                  <div className=" mb-5">
                    <h6 className="fw-bold">
                      <FormattedMessage id="thematic_area_and_related_experience" />
                    </h6>
                    <hr />
                    {userData?.expertises?.map((item) => (
                      <div key={item.id}>
                        <p className="fw-bold">
                          {lang === 'ne' ? item.title_nepali : item.title_english}:
                        </p>
                        <UserDetail id="question.work_experience" value={item.year} />
                        <UserDetail id="question.training_taken" value={item.training_taken} />
                        <UserDetail id="question.training_given" value={item.training_given} />
                      </div>
                    ))}
                  </div>
                  <div className=" mb-5">
                    <h6 className="fw-bold">
                      <FormattedMessage id="_others" />
                    </h6>
                    <hr />
                    <UserDetail
                      id="civil_service_experience"
                      value={userData?.civil_service ? 'yes' : 'no'}
                    />
                    <UserDetail id="other_experiences" value={userData?.other_experience} />
                  </div>
                  <div className=" mb-5">
                    <h6 className="fw-bold">
                      <FormattedMessage id="province_priority" />
                    </h6>
                    <hr />
                    {userData?.priorities?.reverse()?.map((item) => (
                      <div key={item.id}>
                        <UserDetail
                          id={`${item.level + 1}_priority`}
                          value={item.province__title}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
